import { render, staticRenderFns } from "./workEfficiency.vue?vue&type=template&id=0cdf4aa4&scoped=true&"
import script from "./workEfficiency.vue?vue&type=script&lang=js&"
export * from "./workEfficiency.vue?vue&type=script&lang=js&"
import style0 from "./workEfficiency.vue?vue&type=style&index=0&id=0cdf4aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf4aa4",
  null
  
)

export default component.exports